{
  "ui": {
    "feedback": "Comentários",
    "credits": "Créditos",
    "currentMaintainer": "Manutenção atual",
    "maintainerPeriod": "Desde 2026",
    "originalTeam": "Equipe original",
    "creditsCampaigns": "Selva e Natal",
    "moreSettings": "Mais configurações",
    "chooseLanguage": "Escolha seu idioma",
    "notebookTools": "Ferramentas do caderno",
    "visualGuide": "Guia ilustrado",
    "templeSoon": "Em breve",
    "playAdventure": "Jogar",
    "story": "A história",
    "loadingAdventure": "Preparando a aventura…",
    "storyOpening": "Um passeio da escola pela selva. Marco e Sophia exploram com os amigos. Um pássaro colorido chama a atenção de Marco, que o segue entre as árvores. De repente, ele está sozinho. Ajude os exploradores a encontrar o caminho!",
    "storyEnding": "Marco e Sophia chegam juntos ao templo perdido. Um rosto misterioso guarda a entrada. Uma nova aventura espera por eles!",
    "blockCategories": "Abas do caderno",
    "actions": "Ações",
    "loops": "Laços",
    "conditions": "Condições",
    "title": "Run Marco! — Uma aventura no seu caderno",
    "home": "Início do Run Marco",
    "map": "Mapa da aventura",
    "worlds": "Escolha uma aventura",
    "notebook": "Meu caderno",
    "notebookToggle": "Abrir ou fechar o caderno",
    "notebookOpen": "Abrir o caderno",
    "notebookClose": "Ver o caminho",
    "page": "Página {number}",
    "level": "Trilha {number}",
    "run": "Vamos lá!",
    "stop": "Parar",
    "step": "Um passo",
    "stepTitle": "Executar uma instrução",
    "reset": "Voltar ao início",
    "add": "Adicionar",
    "addLabel": "Escolha um bloco para adicionar",
    "addHint": "Conecte os blocos e aperte Jogar.",
    "undo": "Desfazer",
    "clear": "Página nova",
    "hint": "Uma pequena dica",
    "help": "Como jogar",
    "settings": "Configurações",
    "language": "Idioma do jogo",
    "blockLanguage": "Idioma dos blocos",
    "blockLanguageNote": "Você pode escolher outro idioma para os blocos.",
    "musicOn": "Ativar o som",
    "musicOff": "Desativar o som",
    "sound": "Música e efeitos sonoros",
    "speed": "Velocidade da aventura",
    "chooseExplorer": "Escolha seu explorador",
    "explorer": "Explorador",
    "marco": "Marco",
    "sophia": "Sophia",
    "close": "Fechar",
    "done": "Vamos explorar!",
    "loading": "Procurando o caminho…",
    "loadError": "Não foi possível carregar a aventura. Recarregue a página para tentar de novo.",
    "imageError": "Não foi possível carregar algumas imagens. Recarregue a página.",
    "gemGoal": "Encontre a gema",
    "goal": "Encontre a estrela dourada",
    "cover": "Ilumine cada casa uma única vez",
    "lit": "{count} / {total} casas iluminadas",
    "explored": "{count} / {total} trilhas exploradas",
    "facing": "Olhando para {direction} {arrow}",
    "boardLabel": "{name} em {level}, olhando para {direction}. {steps}. {objective}.",
    "up": "cima",
    "down": "baixo",
    "left": "a esquerda",
    "right": "a direita",
    "steps_one": "{count} passo",
    "steps_other": "{count} passos",
    "blocks_one": "{count} bloco",
    "blocks_other": "{count} blocos",
    "stars_one": "{count} estrela",
    "stars_other": "{count} estrelas",
    "place": "Adicionar blocos",
    "atEnd": "No final",
    "insideRepeat": "Dentro de repetir {number}",
    "insideIf": "Dentro de se {number}",
    "insideElse": "Dentro de senão {number}",
    "readyFirst": "Um pequeno passo. Adicione um bloco para avançar e vamos lá!",
    "ready": "Para onde vamos? Faça um plano no seu caderno.",
    "back": "De volta ao início. Seus blocos estão prontos para outra tentativa.",
    "empty": "Primeiro, adicione um bloco ao seu caderno.",
    "win": "Você encontrou o caminho!",
    "winCover": "Você iluminou a trilha!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Que aventura!",
    "simpler": "Você consegue usar menos blocos?",
    "complete": "Trilha concluída! Suas melhores estrelas foram salvas.",
    "next": "Próxima trilha",
    "allWorlds": "Mais aventuras",
    "replay": "Jogar de novo",
    "shortGoal": "Quase! Adicione mais alguns blocos para chegar à estrela.",
    "shortGem": "Quase! Adicione mais alguns blocos para chegar à gema.",
    "shortCover": "Algumas casas ainda estão escuras. Como chegamos até elas?",
    "checking": "Observando o caminho…",
    "paused": "Em pausa. Jogar recomeça desde o início.",
    "going": "Lá vamos nós!",
    "stepped": "Mais um passo. Aperte Um passo ou Jogar para continuar.",
    "clueCover": "Comece em uma borda e percorra toda a figura. Um salto passa por cima de uma casa sem iluminá-la.",
    "clueCondition": "Olhe para o caminho à frente. Uma condição ajuda seu explorador a escolher o que fazer.",
    "clueRepeat": "Quais passos se repetem? Coloque esse padrão dentro de um bloco de repetição.",
    "clueForward": "Avançar segue a direção do seu explorador. Conte as casas até a estrela.",
    "clueGem": "Avançar segue a direção do seu explorador. Conte as casas até a gema.",
    "clueTurn": "Virar muda a direção sem avançar. Siga o caminho com o dedo.",
    "mapNote": "Escolha uma trilha. Suas melhores estrelas ficam salvas.",
    "mapLevel": "Trilha {number}: {name}. {stars}.",
    "locked": "Conclua a trilha anterior para desbloquear esta.",
    "soundBlocked": "Toque no botão de som para ouvir a aventura.",
    "clearTitle": "Vamos abrir uma página nova?",
    "clearNote": "Os blocos desta trilha serão apagados. Desfazer pode trazê-los de volta.",
    "keep": "Manter meus blocos",
    "clearConfirm": "Apagar blocos",
    "fresh": "Uma página nova. Aonde seu próximo plano vai nos levar?",
    "localProgress": "Seu progresso é salvo neste dispositivo.",
    "helpBuild": "Faça um plano",
    "helpBuildText": "Arraste blocos para o caderno e conecte-os, ou toque em um bloco para adicioná-lo. Escolha “Dentro de repetir” para inserir passos em um laço.",
    "helpTurn": "Siga seu explorador",
    "helpTurnText": "Avançar segue o olhar do explorador. Esquerda e direita viram sem avançar. Um salto percorre duas casas.",
    "helpTry": "Tente, observe e tente de novo",
    "helpTryText": "Aperte Jogar para testar o plano ou Um passo para uma instrução. A seta curva volta ao início e mantém seus blocos.",
    "helpWorlds": "Cada aventura tem um objetivo",
    "helpWorldsText": "Na Selva, encontre a gema. No Natal, ilumine cada casa livre uma vez. No Templo e no Egeu, conclua os reparos e os objetivos visíveis e chegue à saída.",
    "noTrail": "Não tem caminho aí! Tente virar antes de avançar.",
    "broken": "Essa ponte está quebrada. Você consegue pular por cima?",
    "blocked": "Algo bloqueia o caminho. Tente um salto ou outra rota.",
    "alreadyLit": "Essa casa já está iluminada. Visite cada casa uma única vez.",
    "loopError": "Este plano se repete sem parar. Tente mudar o laço.",
    "repeatError": "Escolha um número de repetições de 1 a 99.",
    "unsupported": "Remova o bloco não compatível e tente de novo.",
    "connect": "Conecte os blocos em uma só sequência e aperte Jogar.",
    "path": "caminho",
    "steps_many": "{count} passos",
    "blocks_many": "{count} blocos",
    "stars_many": "{count} estrelas",
    "backpack": "Mochila",
    "templeGems": "Gemas do templo",
    "gemsCollected": "Gemas: {count} / {total}",
    "gemsReady": "Todas as gemas foram coletadas!",
    "aegeanTitle": "Os mistérios do Egeu",
    "harbour": "Porto",
    "aegeanDescription": "Explore o porto: conserte estações, reutilize rotinas e envie um número com cada tarefa.",
    "templeBetaNote": "Beta · Estamos revisando os desafios e as lições",
    "aegeanBetaNote": "Beta · Os primeiros 3 níveis do porto",
    "seasonal": "Aventura de temporada",
    "choosePreview": "Escolha um nível de prévia",
    "repairs": "Reparos",
    "reachExit": "Chegue à saída",
    "taskRequirements": "Objetivos da missão",
    "lessonGuided": "Prática guiada · complete o programa fornecido",
    "lessonRepair": "Depuração · corrija o programa fornecido",
    "lessonChallenge": "Desafio · crie seu próprio programa",
    "acc_define_parameter": "Rotina",
    "acc_call_argument": "Chamar rotina",
    "acc_repeat_parameter": "Repetir com a entrada",
    "parameter": "parâmetro",
    "argument": "enviar",
    "callInput": "Entrada desta chamada",
    "inputWaiting": "Execute o programa ou avance uma instrução por vez para ver a próxima entrada.",
    "argumentMismatch": "Uma rotina com parâmetro precisa de uma chamada com um número. Sem parâmetro, use uma chamada normal.",
    "unsetParameter": "Use o parâmetro apenas dentro da rotina que o recebe. Os parâmetros ficam separados da memória compartilhada.",
    "memoryObjective": "Confira o registro de reparos e os objetivos da saída. Qualquer programa que os cumpra é aceito.",
    "gate": "A passagem está bloqueada. Verifique os reparos pendentes.",
    "noPickup": "Fique sobre a ferramenta antes de pegá-la.",
    "creditLead": "Liderança da equipe e desenvolvimento de software",
    "creditArt": "Ilustração e cenários",
    "creditAnimation": "Animação",
    "creditUX": "Design de interface e experiência do usuário",
    "creditDesign": "Design do jogo",
    "creditStory": "Roteiro",
    "creditAudio": "Música e engenharia de som",
    "lightLamp": "Acender lamparina",
    "oilLamp": "Lamparina",
    "dustyStation": "estação com poeira",
    "betaLabel": "Beta",
    "noLamp": "Fique sobre uma lâmpada apagada antes de acendê-la.",
    "collected": "Ferramenta coletada · pronta para usar",
    "dustyPrompt": "Fique sobre uma estação empoeirada antes de usar o pincel.",
    "lampMissing": "Pegue primeiro a lamparina. Veja na mochila.",
    "recursiveRoutine": "Esta rotina chama a si mesma. Use outra rotina; as chamadas recursivas ainda não estão disponíveis."
  },
  "content": {
    "jungle.title": "Expedição na selva",
    "jungle.description": "Siga a trilha até o templo perdido.",
    "jungle-1": "Primeiros passos",
    "jungle-2": "Um pouco mais longe",
    "jungle-3": "Virando a esquina",
    "jungle-4": "Mude de direção",
    "jungle-5": "Siga a trilha",
    "jungle-6": "Uma nova rota",
    "jungle-7": "Novos caminhos",
    "jungle-8": "Cruzamento na selva",
    "jungle-9": "Encontre o caminho",
    "jungle-10": "Pense à frente",
    "jungle-11": "A trilha longa",
    "jungle-12": "Uma rota sinuosa",
    "jungle-13": "Um salto corajoso",
    "jungle-14": "Padrões aparecem",
    "jungle-15": "Repita o ritmo",
    "jungle-16": "Escolha um caminho",
    "jungle-17": "Olhe antes de pular",
    "jungle-18": "Leia a trilha",
    "jungle-19": "Um desvio esperto",
    "jungle-20": "Sob as copas",
    "jungle-21": "Construtor de pontes",
    "jungle-22": "Além do rio",
    "jungle-23": "Explore as ruínas",
    "jungle-24": "Pedra e madeira",
    "jungle-25": "Um salto maior",
    "jungle-26": "Siga as pistas",
    "jungle-27": "Mais alto",
    "jungle-28": "Continue explorando",
    "jungle-29": "Caminhos sinuosos",
    "jungle-30": "O jardim secreto",
    "jungle-31": "Padrões escondidos",
    "jungle-32": "Caminhos antigos",
    "jungle-33": "As últimas curvas",
    "jungle-34": "Rumo ao templo",
    "jungle-35": "Quase chegando",
    "jungle-36": "O templo perdido",
    "winter.title": "Trilha de inverno",
    "winter.description": "Deixe uma luz em cada pegada.",
    "winter-1": "Passos na neve",
    "winter-2": "Outra direção",
    "winter-3": "Cantos congelados",
    "winter-4": "O caminho mais longo",
    "winter-5": "Floco de neve",
    "winter-6": "Laços de inverno",
    "winter-7": "Explorador do gelo",
    "winter-8": "Voltas e curvas",
    "winter-9": "Lógica gelada",
    "winter-10": "Descobridor de padrões",
    "winter-11": "Mestre da trilha",
    "winter-12": "Maravilha de inverno",
    "temple.title": "O templo perdido",
    "temple.description": "Quarenta salas conectadas: restaure um instrumento celeste com ferramentas, memória e suas próprias rotinas."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Lixeira vazia",
    "OPEN_TRASH": "Abrir lixeira",
    "BLOCK_LABEL_BEGIN_STACK": "Início da pilha",
    "WORKSPACE_LABEL_1_STACK": "1 pilha de blocos",
    "WORKSPACE_LABEL_MANY_STACKS": "%1 pilhas de blocos",
    "ARIA_TYPE_FIELD_NUMBER": "número",
    "ARIA_TYPE_FIELD_DROPDOWN": "lista suspensa",
    "ARIA_TYPE_FIELD_IMAGE": "imagem",
    "WORKSPACE_LABEL_PLAIN": "Meu caderno",
    "FIELD_LABEL_EDIT_PREFIX": "Editar %1",
    "BLOCK_LABEL_HAS_INPUT": "tem uma entrada",
    "BLOCK_LABEL_HAS_INPUTS": "tem entradas",
    "BLOCK_LABEL_HAS_BRANCHES": "tem %1 ramos",
    "FIELD_LABEL_OPTION_INDEX": "Opção %1",
    "INPUT_LABEL_EMPTY": "Vazio",
    "BLOCK_LABEL_DISABLED": "desativado",
    "BLOCK_LABEL_COLLAPSED": "recolhido",
    "BLOCK_LABEL_BEGIN_PREFIX": "Início: %1",
    "INPUT_LABEL_END_STATEMENT": "Fim: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "texto",
    "ARIA_TYPE_FIELD_INPUT": "entrada",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "nome da entrada",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "nome da rotina"
  }
}
